import React, { useEffect, useState } from "react";
import echarts from "echarts";
import PropTypes from "prop-types";
import BarChart from "../../components/Charts/BarChart";
import appearance from "../../components/Charts/Appearance";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import KpiCard from "../../components/KPI/KpiCard";
import { useSelections } from "../../context/Selections";
import {
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  Box,
} from "@mui/material";
import Kpi from "../../components/KPI/Kpi";

function OnePageDesktop({ app, config }) {
  const { containers } = config.onePage;

  const title = Kpi({
    app: app,
    objectId: "DaFJeB",
    updatesWithSelection: true,
  });

  const chartsList = [
    <BarChart
      app={app}
      style={{
        flex: 1,
        height: "90%",
        display: "flex",
      }}
      reference={{
        id: "Crjg",
        format: "0.00 a",
        axisFormat: "0.00 a",
        tooltipFormat: "0.00 a",
        barWidth: "60%",
      }}
      multiTooltip
      echarts={echarts}
      autoDataZoom
      options={appearance.barchart("barchartOverview")}
    />,
    <NativeObject
      app={app}
      style={{
        flex: 1,
        height: "90%",
        display: "flex",
        margin: "0px 0px 0px -24px",
        width: "144%",
      }}
      key="ZmdGZ"
      reference={{ id: "ZmdGZ" }}
    />,
    <BarChart
      app={app}
      style={{
        flex: 1,
        height: "90%",
        display: "flex",
      }}
      reference={{
        id: "uMZHD",
        format: "0.00 a",
        axisFormat: "0.00 a",
        tooltipFormat: "0.00 a",
        barWidth: "60%",
        zoom: 0,
      }}
      multiTooltip
      echarts={echarts}
      group="evoltuionGroup1"
      options={appearance.barchart("barchartOverview")}
    />,
    <BarChart
      app={app}
      style={{
        flex: 1,
        height: "90%",
        display: "flex",
      }}
      reference={{
        id: "nbJHn",
        format: "0.00 a",
        axisFormat: "0.00 a",
        tooltipFormat: "0.00 a",
        barWidth: "60%",
        zoom: 100,
      }}
      multiTooltip
      echarts={echarts}
      group="evoltuionGroup2"
      options={appearance.barchart("barchartOverview")}
    />,
  ];

  return (
    <div className="app onePage">
      <div className="appContent">
        <div style={{ width: "100%", padding: "12px 12px 0px 12px" }}>
          <Divider
            flexItem
            orientation="horizontal"
            variant="middle"
            sx={{
              display: "flex",
            }}
          >
            <Grid
              container
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid item xs>
                <Box className="title" component={"span"}>
                  {title}
                </Box>
              </Grid>
            </Grid>
          </Divider>
        </div>
        <LayoutCardsWrapper>
          {/* KPIS */}
          <CardWrapper>
            {containers[0].cards.map((card, i) => (
              <KpiCard
                app={app}
                key={card.title.hardTitle}
                KPITitle={card.title.hardTitle}
                iconId={card.nativeObjectIds.iconId}
                percentageId={card.nativeObjectIds.percentageId}
                goalValueId={card.nativeObjectIds.greyValueId}
                valueId={card.nativeObjectIds.valueId}
                chartTemplate={chartsList[i]}
                imageId={card.nativeObjectIds.imageId}
                redirectPath={card.redirectPath}
              ></KpiCard>
            ))}
          </CardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OnePageDesktop.defaultProps = {
  app: null,
  config: {},
};

OnePageDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OnePageDesktop;
